export default "__VITE_ASSET__DAC71Ol6__"